import { Routes, Route } from 'react-router-dom';
import Dashboard from './pages/dashboard/Dashboard';
import RaspiDetails from './pages/raspi-details/RaspiDetails';
import Experiments from './pages/experiments/Experiments';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/raspi-details" element={<RaspiDetails />} />
      <Route path="/experiments" element={<Experiments />} />
    </Routes>
  );
};

export default AppRoutes; 